import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    title: "Home",
    path: "/",
    newTab: false,
  },
  {
    id: 2,
    title: "About",
    path: "/about",
    newTab: false,
  },
  {
    id: 3,
    title: "Blog",
    newTab: false,
    submenu: [
      { id: 31, title: "Our Blogs", path: "/our-blogs", newTab: false },
      {
        id: 32,
        title: "Categories",
        path: "/categories",
        newTab: false,
      },
      {
        id: 33,
        title: "Article",
        path: "/article",
        newTab: false,
      },
    ],
  },
  {
    id: 4,
    title: "Services",
    path: "/services",
    newTab: false,
  },
  {
    id: 5,
    title: "Events",
    path: "/events",
    newTab: false,
  },
  {
    id: 6,
    title: "Careers",
    path: "/careers",
    newTab: false,
  },
  {
    id: 7,
    title: "Support",
    path: "/contact",
    newTab: false,
  },
];
export default menuData;
